// Teksten op het stemscherm. Admins kunnen ze per tekst overschrijven via
// settings.voter_texts; ontbrekende of lege teksten vallen terug op de
// standaardtekst hieronder.

export const VOTER_TEXT_DEFAULTS = {
  no_game_title: 'Geen actieve wedstrijden vandaag',
  no_game_body: 'Er zijn vandaag geen wedstrijden gepland.',
  before_game_title: 'Wedstrijd start over {aftellen}',
  before_game_body:
    'Kom terug om {tijd} uur om je stem uit te brengen voor de MVP van deze wedstrijd.',
  voting_title: 'Stem op de {sponsor} MVP',
  voting_details_intro:
    'Laat je gegevens achter om kans te maken op een prijs. We gebruiken ze alleen om contact met je op te nemen als je wint.',
  voting_submit: 'Stem uitbrengen',
  voted_intro: 'Bedankt voor je stem!',
  voted_title: 'Bedankt voor je stem!',
  voted_choice: 'Je hebt gestemd op:',
  voted_body: 'Aan het einde van de wedstrijd zal de winnaar worden omgeroepen.',
  closed_title: 'Stemmen is gesloten',
  closed_body: 'Aan het einde van de wedstrijd zal de winnaar worden omgeroepen.',
  winner_title: 'Gefeliciteerd, je hebt gewonnen!',
  winner_body:
    'Je stem is getrokken als prijswinnaar. We nemen contact met je op via de gegevens die je hebt achtergelaten.',
};

export type VoterTextKey = keyof typeof VOTER_TEXT_DEFAULTS;
export type VoterTexts = Record<VoterTextKey, string>;

const isVoterTextKey = (key: string): key is VoterTextKey =>
  Object.prototype.hasOwnProperty.call(VOTER_TEXT_DEFAULTS, key);

/** Standaardteksten aangevuld met de aangepaste teksten van de admin */
export function resolveVoterTexts(overrides: unknown): VoterTexts {
  const texts: VoterTexts = { ...VOTER_TEXT_DEFAULTS };
  if (!overrides || typeof overrides !== 'object') return texts;

  for (const [key, value] of Object.entries(overrides)) {
    if (isVoterTextKey(key) && typeof value === 'string' && value.trim()) {
      texts[key] = value.trim();
    }
  }
  return texts;
}

/** Alleen de teksten die afwijken van de standaard, om op te slaan */
export function voterTextOverrides(texts: Partial<VoterTexts>): Partial<VoterTexts> {
  const overrides: Partial<VoterTexts> = {};
  for (const [key, value] of Object.entries(texts)) {
    const trimmed = value?.trim();
    if (isVoterTextKey(key) && trimmed && trimmed !== VOTER_TEXT_DEFAULTS[key]) {
      overrides[key] = trimmed;
    }
  }
  return overrides;
}

/**
 * Vult {sponsor}, {aftellen} en {tijd} in. Een lege waarde laat geen dubbele
 * spatie achter, zodat "Stem op de {sponsor} MVP" zonder sponsor
 * "Stem op de MVP" wordt.
 */
export function fillVoterText(text: string, values: Record<string, string | null | undefined>) {
  return text
    .replace(/\{(\w+)\}/g, (match, name: string) =>
      name in values ? (values[name] ?? '') : match,
    )
    .replace(/ {2,}/g, ' ')
    .trim();
}
